import callApi, { ENDPOINTS } from 'utils/api/callApi'
import { RequestType, IAutocompleteSearchResult } from '../types'

export interface ILoadSuggestionsProps {
  value?: string
  type: string // TODO: Port types here from DPLAutocomplete.jsx
  dispatch: (value: { type: RequestType; payload: IAutocompleteSearchResult['namesearch'] }) => void
}

export const loadSuggestions = ({ dispatch, type, value }: ILoadSuggestionsProps) => {
  if (value && value.length > 1) {
    dispatch({ type: RequestType.request, payload: [] })
    callApi({
      endpoint: ENDPOINTS.search,
      params: {
        perPage: 10,
        filters: {
          search_options: [{ type }],
          searchTerm: `*${value}*`,
        },
      },
    }).then((data: IAutocompleteSearchResult) => {
      dispatch({ type: RequestType.success, payload: data.namesearch })
    })
  }
}
